import { render, staticRenderFns } from "./help-text.vue?vue&type=template&id=06ff3963"
import script from "./help-text.vue?vue&type=script&lang=js"
export * from "./help-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports